import './LoadingSpinner.css';

export const LoadingSpinner = () => (
    <div className="loader-container">
        <span className="loader"></span>
    </div>
);
